import React, { useState, useEffect } from 'react'
import CardCable from './cardcable'
import CardPoP from './cardPoP'
import { ReactComponent as Close } from '../../icons/close.svg'
import { ReactComponent as Fold } from '../../icons/arrow-down.svg'

import InfoTitle from './infoTitle'
import Contact from './contact'
import styled, { css } from 'styled-components'

const InfoDiv = styled.div`
  position: fixed;
  right: 0px;
  top: calc(100vh - 300px);
  background: #fff;
  padding: 1rem 2rem;
  width: calc(100vw - 4rem);
  text-align: left;
  min-height: 100vh;
  z-index: 15;
  border-radius: 2rem 2rem 0rem 0rem;
  box-shadow: 0px -2px 40px rgba(7, 43, 59, 0.15);
  transition: top 0.4s;
  ${props =>
    !props.mobile &&
    css`
      top: 0px;
      padding: 1.5rem 16px 24px 32px;
      width: 200px;
      border-radius: 2rem 0rem 0rem 0rem;
    `};

  ${props =>
    props.mobile === true &&
    props.detail === true &&
    css`
      top: 1rem;
      transition: top 1s;
    `};
`

const Content = styled.div`
  padding: 0rem;
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 0rem;
  right: 0rem;
  padding: 0rem;
  width: 32px;
  height: 32px;
  fill: rgb(0, 151, 172);
  padding: 16px;
  z-index: 16;
  ${props =>
    props.mobile === 'false' &&
    css`
      fill: #444;
      cursor: pointer;
      &:hover {
        fill: rgb(0, 151, 172);
        -webkit-transition: fill 0.5s;
        transition: fill 0.3s;
      }
    `};
`

const HideCard = styled(Fold)`
  position: absolute;
  top: 0rem;
  right: 3rem;
  padding: 0rem;
  width: 32px;
  height: 32px;
  fill: rgb(0, 151, 172);
  padding: 16px;
  z-index: 16;
  ${props =>
    !props.mobile &&
    css`
      fill: #444;
      cursor: pointer;
      &:hover {
        fill: rgb(0, 151, 172);
        -webkit-transition: fill 0.5s;
        transition: fill 0.3s;
      }
    `};
`

const Info = ({ selected, mobile, h, w, reset, urlTo }) => {
  const closeAndExit = e => {
    reset()
    urlTo('', 'close', 'card cable')
  }
  const [detail, setDetail] = useState(false)

  useEffect(() => {
    setDetail(false)
  }, [selected.data.name])
  return (
    <InfoDiv className="infocard" mobile={mobile} detail={detail}>
      <Content>
        <CloseIcon onClick={closeAndExit} mobile={mobile.toString()} />
        {mobile && selected.type === 'cable' && <>{detail && <HideCard onClick={() => setDetail(false)} mobile={mobile} />}</>}

        <InfoTitle data={selected.data} type={selected.type} />

        {selected.type === 'pop' ? (
          <CardPoP key={'cardP-' + selected.data.name} pop={selected.data} reset={closeAndExit} mobile={mobile} />
        ) : (
          <CardCable
            key={'cardC-' + selected.data.name}
            cable={selected.data}
            reset={closeAndExit}
            mobile={mobile}
            urlTo={urlTo}
            h={h}
            w={w}
            toggle={() => setDetail(!detail)}
            detail={detail}
          />
        )}
        <Contact mobile={mobile} />
      </Content>
    </InfoDiv>
  )
}

export default Info
